import { GENERATOR } from "../constants";

const TypeIcon = ({ type, color }) => {
  const iconMap = {
    [GENERATOR.ROAD]: <RoadIcon color={color} />,
    [GENERATOR.DUNGEON]: <DungeonIcon color={color} />,
    [GENERATOR.WILDERNESS]: <WildernessIcon color={color} />,
    [GENERATOR.TAVERN]: <TavernIcon color={color} />,
  };
  return iconMap[type];
};

const RoadIcon = ({ color }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_6" clipPath="url(#clip0_2309_362)">
        <path
          id="Vector"
          d="M1.37507 12.5301C1.67507 13.3701 3.59507 13.6401 5.70507 14.3501C7.09507 14.8201 2.98507 16.1301 0.715074 16.9601C0.265074 17.1301 0.405074 17.7001 0.895074 17.7001H17.8151C18.3351 17.7001 18.6851 17.2701 18.5351 16.8501C18.3151 16.2401 16.6651 15.4101 14.8651 14.7701C12.1751 13.8101 8.47507 13.7001 7.84507 12.5501C7.09507 11.1901 10.4751 11.7101 10.4751 11.7101V10.7101C10.4751 10.7101 0.585074 10.3401 1.37507 12.5301Z"
          fill={color}
        />
        <path
          id="Vector_2"
          d="M14.4751 9.70011L14.4551 12.6801L12.4751 12.7001V9.70011C10.6351 9.70011 9.44505 7.77011 10.2651 6.12011L12.1351 1.22011C12.6051 -0.00989258 14.3451 -0.00989258 14.8151 1.22011L16.6851 6.12011C17.5051 7.76011 16.3151 9.70011 14.4751 9.70011Z"
          fill={color}
        />
        <path
          id="Vector_3"
          d="M5.475 8.70008V9.70008H3.475V8.70008C2.485 8.70008 1.785 7.74008 2.085 6.80008L3.495 2.38008C3.835 1.48008 5.105 1.48008 5.445 2.38008L6.855 6.80008C7.155 7.74008 6.455 8.70008 5.465 8.70008H5.475Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2309_362">
          <rect
            width="18.13"
            height="17.4"
            fill="white"
            transform="translate(0.435059 0.300049)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const DungeonIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M3.89786 14.5539H0.659246C0.295228 14.5539 0 14.8497 0 15.2144V17.3395C0 17.7042 0.295228 18 0.659246 18H3.89786C4.26188 18 4.55711 17.7042 4.55711 17.3395V15.2144C4.55711 14.8497 4.26188 14.5539 3.89786 14.5539ZM3.89786 10.0452H0.659246C0.295228 10.0452 0 10.341 0 10.7057V12.8308C0 13.1955 0.295228 13.4913 0.659246 13.4913H3.89786C4.26188 13.4913 4.55711 13.1955 4.55711 12.8308V10.7057C4.55711 10.341 4.26188 10.0452 3.89786 10.0452ZM4.58577 6.8575L1.8628 5.13444C1.32938 4.81538 1.06655 4.85358 0.888263 5.16316C0.497014 5.8429 0.103186 7.30722 0.0573258 8.40826C0.0395548 8.83271 0.27459 9.01421 0.938423 9.01421H4.12487C4.31978 9.01421 4.49978 8.85769 4.54192 8.63025L4.81536 7.37442C4.85549 7.1576 4.75517 6.95859 4.58606 6.8575H4.58577ZM6.59218 5.19187C6.66756 5.11089 6.72947 4.99975 6.70683 4.78982C6.68791 4.61321 5.41872 1.46029 5.33101 1.28626C5.2433 1.11223 4.98419 1.01373 4.70043 1.11395C4.18306 1.2966 2.19042 2.91168 2.00611 3.41137C1.89834 3.70315 1.98662 3.92858 2.14943 4.04316C2.32571 4.16722 5.1169 5.88799 5.24502 5.96725C5.40754 6.06805 5.63598 5.99023 5.73229 5.90982C5.78789 5.86329 6.49902 5.29181 6.59218 5.19187ZM11.3792 0.338573C10.8667 -0.016091 7.58362 -0.200172 6.64979 0.338573C6.38093 0.493936 6.31873 0.777381 6.42048 1.08523C6.48813 1.28999 7.7 4.5865 7.73898 4.73239C7.78828 4.91733 8.07261 5.06925 8.19758 5.077C8.26981 5.0816 9.72388 5.08619 9.86003 5.077C9.96866 5.06954 10.114 4.99487 10.2326 4.78982C10.3218 4.63618 11.5531 1.21475 11.6085 1.0278C11.6638 0.840847 11.6268 0.510018 11.3792 0.338573ZM9.31543 6.19699H8.71351C8.55529 6.19699 8.42689 6.32565 8.42689 6.48417V16.5641C8.42689 16.7226 8.55529 16.8513 8.71351 16.8513H9.31543C9.47365 16.8513 9.60206 16.7226 9.60206 16.5641V6.48417C9.60206 6.32565 9.47365 6.19699 9.31543 6.19699ZM7.16572 6.71391C7.16572 6.71391 6.62342 7.09529 6.36316 7.46058C6.14847 7.76183 6.16252 7.76154 6.16252 7.92006V16.5641C6.16252 16.7226 6.29093 16.8513 6.44915 16.8513H7.05107C7.20929 16.8513 7.3377 16.7226 7.3377 16.5641V6.88622C7.3377 6.7277 7.32394 6.71391 7.16572 6.71391ZM17.341 14.5539H14.1024C13.7384 14.5539 13.4432 14.8497 13.4432 15.2144V17.3395C13.4432 17.7042 13.7384 18 14.1024 18H17.341C17.7051 18 18.0003 17.7042 18.0003 17.3395V15.2144C18.0003 14.8497 17.7051 14.5539 17.341 14.5539ZM17.341 10.0452H14.1024C13.7384 10.0452 13.4432 10.341 13.4432 10.7057V12.8308C13.4432 13.1955 13.7384 13.4913 14.1024 13.4913H17.341C17.7051 13.4913 18.0003 13.1955 18.0003 12.8308V10.7057C18.0003 10.341 17.7051 10.0452 17.341 10.0452ZM13.8754 9.01421H17.0619C17.7257 9.01421 17.9607 8.83271 17.943 8.40826C17.8968 7.30722 17.5033 5.8429 17.1117 5.16316C16.9335 4.85358 16.6706 4.81538 16.1372 5.13444L13.4142 6.8575C13.2451 6.95859 13.1448 7.1576 13.1849 7.37442L13.4584 8.63025C13.5005 8.85741 13.6805 9.01421 13.8754 9.01421ZM15.9939 3.41137C15.8096 2.91168 13.8169 1.2966 13.2996 1.11395C13.0158 1.01373 12.7567 1.11223 12.669 1.28626C12.5813 1.46029 11.3121 4.61321 11.2932 4.78982C11.2705 4.99975 11.3324 5.11089 11.4078 5.19187C11.501 5.29181 12.2121 5.86329 12.2677 5.90982C12.364 5.99023 12.5925 6.06805 12.755 5.96725C12.8831 5.88799 15.6743 4.16722 15.8506 4.04316C16.0134 3.92858 16.1017 3.70315 15.9939 3.41137ZM10.8346 6.71391C10.6763 6.71391 10.6626 6.7277 10.6626 6.88622V16.5641C10.6626 16.7226 10.791 16.8513 10.9492 16.8513H11.5511C11.7094 16.8513 11.8378 16.7226 11.8378 16.5641V7.92006C11.8378 7.76154 11.8518 7.76183 11.6371 7.46058C11.3769 7.09529 10.8346 6.71391 10.8346 6.71391Z"
        fill={color}
      />
    </svg>
  );
};

const WildernessIcon = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_7" clipPath="url(#clip0_2309_389)">
        <path
          id="Vector"
          d="M4.23002 5.33004L3.77002 4.23004L6.01002 0.790039L8.38002 4.24004L8.00002 5.33004L6.07002 3.69004L4.23002 5.33004Z"
          fill={color}
        />
        <path
          id="Vector_2"
          d="M18 8.54988V12.5499L16.16 11.3299C15.46 10.8599 14.54 10.8599 13.83 11.3299L13.16 11.7799C12.46 12.2499 11.54 12.2499 10.83 11.7799L10.16 11.3299C9.45999 10.8599 8.53999 10.8599 7.82999 11.3299L7.15999 11.7799C6.45999 12.2499 5.53999 12.2499 4.82999 11.7799L4.15999 11.3299C3.45999 10.8599 2.53999 10.8599 1.82999 11.3299L-0.0100098 12.5499V9.54988L3.03999 5.29988L3.85999 7.03988L6.06999 5.03988L8.23999 7.03988L8.94999 5.29988L11.39 8.54988H14V7.54988C14 7.54988 11.13 7.64988 12.52 4.53988C12.81 3.88988 13.48 2.20988 13.98 0.779883C14.14 0.329883 14.92 0.329883 15.08 0.779883C15.62 2.27988 16.38 4.32988 16.48 4.53988C17.95 7.82988 15.01 7.54988 15.01 7.54988V8.54988H18.01H18Z"
          fill={color}
        />
        <path
          id="Vector_3"
          d="M18 14.5499L16.12 13.2899C15.44 12.8399 14.56 12.8199 13.86 13.2499L12.94 13.8099C12.22 14.2499 11.29 14.2199 10.61 13.7199L10.27 13.4699C9.52001 12.9199 8.50001 12.9299 7.76001 13.4899L7.50001 13.6899C6.82001 14.2099 5.89001 14.2599 5.16001 13.8199L4.14001 13.2099C3.45001 12.7999 2.58001 12.8199 1.91001 13.2699L0.0100098 14.5399V17.5399H18V14.5399V14.5499Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2309_389">
          <rect
            width="18"
            height="17.1"
            fill="white"
            transform="translate(0 0.449951)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const TavernIcon = ({ color }) => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_4" clipPath="url(#clip0_2309_371)">
        <g id="Group">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.15507 8H1.94507V15H3.94507V10H4.94507V15H6.94507V10H7.94507V15H9.94507V10H10.9451V15H12.9451V13.62C12.9451 13.24 13.1551 12.9 13.4951 12.73L16.3951 11.28C16.7351 11.11 16.9451 10.76 16.9451 10.39V5.97C16.9451 5.43 16.5051 5 15.9751 5H13.9451V4H11.4651C11.1451 4 10.8551 4.18 10.7151 4.46L9.30507 7.29C9.08507 7.72 8.64507 8 8.15507 8ZM14.3951 10.28L12.9451 11V7.5C12.9451 7.22 13.1651 7 13.4451 7H14.4451C14.7251 7 14.9451 7.22 14.9451 7.5V9.38C14.9451 9.76 14.7351 10.11 14.3951 10.28Z"
            fill={color}
          />
          <g id="Group_2">
            <path
              id="Vector_2"
              d="M2.33508 6.98999C2.33508 6.98999 2.37508 6.99999 2.39508 6.99999H2.55508C2.48508 6.99999 2.40508 6.99999 2.33508 6.98999Z"
              fill={color}
            />
            <path
              id="Vector_3"
              d="M8.15507 8H1.94507V15H3.94507V10H4.94507V15H6.94507V10H7.94507V15H9.94507V10H10.9451V15H12.9451V13.62C12.9451 13.24 13.1551 12.9 13.4951 12.73L16.3951 11.28C16.7351 11.11 16.9451 10.76 16.9451 10.39V5.97C16.9451 5.43 16.5051 5 15.9751 5H13.9451V4H11.4651C11.1451 4 10.8551 4.18 10.7151 4.46L9.30507 7.29C9.08507 7.72 8.64507 8 8.15507 8ZM14.3951 10.28L12.9451 11V7.5C12.9451 7.22 13.1651 7 13.4451 7H14.4451C14.7251 7 14.9451 7.22 14.9451 7.5V9.38C14.9451 9.76 14.7351 10.11 14.3951 10.28Z"
              fill={color}
            />
            <path
              id="Vector_4"
              d="M0.945068 16.5V17.5C0.945068 17.78 1.16507 18 1.44507 18H14.4451C14.7251 18 14.9451 17.78 14.9451 17.5V16.5C14.9451 16.22 14.7251 16 14.4451 16H1.44507C1.16507 16 0.945068 16.22 0.945068 16.5Z"
              fill={color}
            />
          </g>
        </g>
        <path
          id="Vector_5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0451 2.99C14.0451 2.99 13.9851 3 13.9451 3H10.9451C10.3951 3.01 10.0851 3.09 9.74505 3.5C9.14505 4.22 8.70505 5.48 8.54505 5.8L8.16505 6.56C8.03505 6.83 7.75505 7 7.45505 7H2.55505C2.48505 7 2.40505 7 2.33505 6.99C2.30505 6.99 2.27505 6.98 2.24505 6.98C1.01505 6.83 0.0550537 5.78 0.0550537 4.5C0.0550537 3.14 1.14505 2.03 2.49505 2C2.72505 0.86 3.73505 0 4.94505 0C5.87505 0 6.68505 0.51 7.11505 1.26C7.35505 1.09 7.63505 1 7.94505 1C8.45505 1 8.90505 1.25 9.16505 1.64C9.56505 0.67 10.5051 0 11.6151 0C12.4751 0 13.2451 0.42 13.7251 1.06C14.0551 1.48 14.2351 2.01 14.2451 2.58C14.2451 2.76 14.1851 2.95 14.0451 2.99Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2309_371">
          <rect
            width="16.89"
            height="18"
            fill="white"
            transform="translate(0.0550537)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TypeIcon;
